import { supabase } from '../../lib/supabase';

// 템플릿 정보 맵핑
const templateInfo = {
  // Premium Templates
  1: { name: '전문가', type: 'premium' },
  2: { name: '블루미니멀', type: 'premium' },
  4: { name: '신뢰', type: 'premium' },
  5: { name: '투컬럼', type: 'premium' },
  6: { name: '사이드바', type: 'premium' },
  7: { name: '진중', type: 'premium' },
  9: { name: '옐로우헤더', type: 'premium' },
  10: { name: '블랙테마', type: 'premium' },
  3: { name: '모던', type: 'premium' },
  18: { name: '그레이', type: 'premium' },
  // Standard Templates
  8: { name: '전통형', type: 'standard' },
  11: { name: '그린', type: 'standard' },
  12: { name: '테이블', type: 'standard' },
  13: { name: '클린', type: 'standard' },
  14: { name: '골드', type: 'standard' },
  15: { name: '블루', type: 'standard' },
  16: { name: '사이드', type: 'standard' },
  17: { name: '박스형', type: 'standard' },
  19: { name: '심플', type: 'standard' },
  20: { name: '미니멀', type: 'standard' }
};

/**
 * PDF 다운로드 정보를 DB에 저장
 */
export const savePDFDownloadInfo = async ({
  userId,
  sessionId,
  templateId,
  language = 'kr',
  browserInfo
}) => {
  try {
    // 템플릿 정보 가져오기
    const template = templateInfo[templateId] || { name: 'Unknown', type: 'standard' };
    
    // pdf_downloads 테이블에 저장
    const { data, error } = await supabase
      .from('pdf_downloads')
      .insert({
        user_id: userId,
        session_id: sessionId,
        template_id: templateId,
        template_name: template.name,
        download_language: language,
        browser_info: browserInfo
      })
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    // 추적 실패해도 PDF 다운로드는 계속 진행되도록 에러를 throw하지 않음
    return null;
  }
};

/**
 * 사용자의 PDF 다운로드 통계 조회
 */
export const getUserPDFDownloadStats = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('pdf_downloads')
      .select('template_id, template_name, download_language, created_at')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    return [];
  }
};

/**
 * 템플릿별 다운로드 횟수 조회
 */
export const getTemplateDownloadCounts = async () => {
  try {
    const { data, error } = await supabase
      .from('pdf_downloads')
      .select('template_id, template_name')
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    // 템플릿별로 카운트 집계
    const counts = data.reduce((acc, item) => {
      const key = `${item.template_id}_${item.template_name}`;
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {});

    return counts;
  } catch (error) {
    return {};
  }
};